import React, { useState } from 'react';
import { auth } from '../config/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err) {
      setError(err.message.replace('Firebase: ', ''));
    }
  };

  if (sent) return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.logo}>Listlytics</h1>
        <div style={styles.verifyBox}>
          <p style={styles.verifyIcon}>📬</p>
          <h2 style={styles.verifyTitle}>Check your email!</h2>
          <p style={styles.verifyText}>
            We sent a password reset link to <strong>{email}</strong>.
            Click the link to set a new password, then come back and log in.
          </p>
          <button style={styles.button} onClick={() => navigate('/login')}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.logo}>Listlytics</h1>
        <p style={styles.subtitle}>Reset your password</p>
        <p style={styles.instructions}>
          Enter your email and we'll send you a link to reset your password.
        </p>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleReset}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <button type="submit" style={styles.button}>
            Send Reset Link
          </button>
        </form>
        <p style={styles.toggle}>
          Remember your password?{' '}
          <span style={styles.toggleLink} onClick={() => navigate('/login')}>
            Log in
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#f5f5f5', fontFamily: 'sans-serif' },
  card: { background: '#fff', borderRadius: 16, padding: 32, width: '100%',
    maxWidth: 400, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' },
  logo: { fontSize: 28, fontWeight: 'bold', textAlign: 'center',
    margin: '0 0 8px', color: '#2E86AB' },
  subtitle: { textAlign: 'center', color: '#666', margin: '0 0 8px' },
  instructions: { textAlign: 'center', color: '#888', fontSize: 14,
    margin: '0 0 24px', lineHeight: 1.5 },
  error: { background: '#fee', color: '#c00', padding: 10, borderRadius: 8,
    fontSize: 14, marginBottom: 16 },
  input: { width: '100%', padding: 12, marginBottom: 12, fontSize: 15,
    border: '1px solid #ddd', borderRadius: 8, boxSizing: 'border-box' },
  button: { width: '100%', padding: 14, background: '#2E86AB', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 'bold',
    cursor: 'pointer', marginBottom: 16 },
  toggle: { textAlign: 'center', fontSize: 14, color: '#666', margin: 0 },
  toggleLink: { color: '#2E86AB', cursor: 'pointer', fontWeight: 'bold' },
  verifyBox: { textAlign: 'center' },
  verifyIcon: { fontSize: 48, margin: '0 0 12px' },
  verifyTitle: { fontSize: 22, fontWeight: 'bold', margin: '0 0 12px' },
  verifyText: { fontSize: 15, color: '#555', lineHeight: 1.6, margin: '0 0 24px' },
};



